import { CategoryType } from "../exercises.types";
import { ThemeModule } from "./theme.types";
import { MicroCoursBiaisConfirmation } from "../comprendre/MicroCours/MicroCoursBiaisConfirmation";
import { QuizBiaisConfirmation } from "../comprendre/Quiz/QuizBiaisConfirmation";

export const biaisConfirmationTheme: ThemeModule = {
  id: "biais-confirmation",
  title: "Biais de confirmation",
  description:
    "Notre tendance a chercher ce qui confirme nos idees. Ce theme t'aide a la reperer et a penser plus objectivement.",
  longDescription:
    "Le biais de confirmation influence nos choix : il nous pousse a selectionner les informations qui vont dans notre sens et a ignorer celles qui nous contredisent. Ce theme t'apprend a reconnaitre ce biais, comprendre son origine et utiliser des strategies simples pour le limiter.",
  category: CategoryType.COMPRENDRE,
  keywords: ["biais", "raisonnement", "esprit critique", "cognition"],
  tags: ["biais", "raisonnement", "esprit critique", "cognition"],
  audience: "adult",
  microCourses: [MicroCoursBiaisConfirmation],
  quizzes: [QuizBiaisConfirmation],
  estimatedDuration: 15,
  level: "intermediaire",
  minAgeBand: "12-15",
  allowedRoles: ["parent", "enseignant", "eleve"],
  objectives: [
    "Reconnaitre une situation influencee par le biais",
    "Comprendre pourquoi ce biais apparait",
    "Identifier ses croyances preexistantes",
    "Chercher des informations contradictoires",
    "Adapter sa prise de decision",
    "Limiter l'impact du biais dans la vie quotidienne",
  ],
  modulesMeta: [
    {
      id: "biais_confirmation_adulte",
      title: "Biais de confirmation - Version adulte",
      description: "Parcours adulte pour analyser ses decisions et chercher la contradiction.",
      microCoursesCount: 5,
    },
    {
      id: "biais_confirmation_enfant",
      title: "Biais de confirmation - Version enfant",
      description: "Parcours enfant pour comprendre pourquoi on voit ce que l'on veut voir.",
      microCoursesCount: 3,
    },
  ],
  microCoursesMeta: [
    { id: "bc_mc1", title: "Pourquoi ton cerveau cherche a avoir raison", durationLabel: "7 min", difficulty: "medium" },
    { id: "bc_mc2", title: "Comment savoir si ton jugement est biaise", durationLabel: "6 min", difficulty: "medium" },
    { id: "bc_mc3", title: "L'art de chercher la contradiction", durationLabel: "7 min", difficulty: "medium" },
    { id: "bc_mc4", title: "Le biais dans les relations humaines", durationLabel: "8 min", difficulty: "medium" },
    { id: "bc_mc5", title: "Les reseaux sociaux : amplificateurs de certitudes", durationLabel: "7 min", difficulty: "medium" },
    { id: "bc_kid1", title: "Pourquoi on ne voit que ce qu'on veut voir", durationLabel: "5 min", difficulty: "easy" },
    { id: "bc_kid2", title: "Chercher les idees differentes", durationLabel: "5 min", difficulty: "easy" },
    { id: "bc_kid3", title: "Les videos qui montrent toujours la meme chose", durationLabel: "5 min", difficulty: "easy" },
  ],
  quizzesMeta: [
    {
      id: "quiz_biais_confirmation",
      title: "Quiz - Biais de confirmation",
      durationLabel: "5 min",
      level: "intermediate",
    },
  ],
  resourcesMeta: [
    { id: "bc_res_fiche", title: "Reperer le biais de confirmation", type: "fiche", audience: "adult", durationLabel: "10 min" },
    { id: "bc_res_activite", title: "Activite familiale : voir l'autre point de vue", type: "activite", audience: "parent", durationLabel: "15 min" },
    { id: "bc_res_guide", title: "Guide enseignant : debattre sans bulle", type: "guide", audience: "teacher", durationLabel: "12 min" },
    { id: "bc_res_parents", title: "Fiche parents : parler du biais au quotidien", type: "parents", audience: "parent", durationLabel: "8 min" },
  ],
  moduleIds: ["biais_confirmation_adulte", "biais_confirmation_enfant"],
  microCourseIds: ["bc_mc1", "bc_mc2", "bc_mc3", "bc_mc4", "bc_mc5", "bc_kid1", "bc_kid2", "bc_kid3"],
  quizIds: ["quiz_biais_confirmation", "quiz-biais-1"],
  resourceIds: ["bc_res_fiche", "bc_res_activite", "bc_res_guide", "bc_res_parents"],
};
